import { useState, memo, Fragment } from "react";
import { Modal } from "@app/shared/Modals";
import { Accordion } from "@app/shared/Accordion";
import { QESButton } from "@app/shared/qes-standards/Button";
import { ProviderNetworkImportGridRow } from "@app/provider-network-imports/components/ProviderNetworkImportGridRow";
import { useImportConfig, useImportSaga } from "@app/provider-network-imports/hooks";
import { AccessPointProcessingGroup } from "@app/provider-network-imports/models";

function nonMemoProviderNetworkImportGridGroup({ group }: { group: AccessPointProcessingGroup }) {
  //const { versionId } = useParams<{ networkId?: string, versionId?: string }>();
  const [showRemoveGroupAlert, setShowRemoveGroupAlert] = useState(false);
  //const { isActivated } = useVersions();
  const { getGroup, removeGroup, runGroup } = useImportConfig();
  const { saga } = useImportSaga();

  const groupState = getGroup(group);
  //const isActive = isActivated(+versionId);

  const rows = [];
  const transformRows = groupState.transformSteps ? groupState.transformSteps.map((step) => (<ProviderNetworkImportGridRow key={step} step={step} />)) : null;
  const appendRows = groupState.appendSteps ? groupState.appendSteps.map((step) => (<ProviderNetworkImportGridRow key={step} step={step} />)) : null;
  const filterRows = groupState.filterSteps ? groupState.filterSteps.map((step) => (<ProviderNetworkImportGridRow key={step} step={step} />)) : null;
  const validateRows = groupState.validateSteps ? groupState.validateSteps.map((step) => (<ProviderNetworkImportGridRow key={step} step={step} />)) : null;
  const queryRows = groupState.querySteps ? groupState.querySteps.map((step) => (<ProviderNetworkImportGridRow key={step} step={step} />)) : null;
  if (!!transformRows) { rows.push(...transformRows); }
  if (!!appendRows) { rows.push((rows.length !== 0) ? <tr key={1}><td colSpan={100} className="p-0 border" /></tr> : null, ...appendRows); }
  if (!!filterRows) { rows.push((rows.length !== 0) ? <tr key={2}><td colSpan={100} className="p-0 border" /></tr> : null, ...filterRows); }
  if (!!validateRows) { rows.push((rows.length !== 0) ? <tr key={3}><td colSpan={100} className="p-0 border" /></tr> : null, ...validateRows); }
  if (!!queryRows) { rows.push((rows.length !== 0) ? <tr key={4}><td colSpan={100} className="p-0 border" /></tr> : null, ...queryRows); }

  const table = (
    <table className="table">
      <thead>
        <tr>
          <th scope="col" />
          <th scope="col">Status</th>
          <th scope="col">Summary</th>
          {/*
            TODO: add back when we have configurable steps
            <th scope="col" className="text-end">Results</th>
            <th scope="col" className="text-end">Record %</th>
            <th scope="col" className="text-center">Edit</th>
          */}
          <th scope="col" className="text-center">Enabled</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>
  );
  const remove = () => {
    removeGroup(group);
    setShowRemoveGroupAlert(false);
  };

  const alert = (
    <Modal
      closeModal={() => { setShowRemoveGroupAlert(false) }}
      content={{
        body: <p>Are you sure you want to delete the group &quot;{groupState.name}&quot;?</p>,
        cancelButtonText: "Cancel",
        confirmButtonAction: () => remove(),
        confirmButtonText: "Delete",
        confirmButtonType: "primary-danger",
        title: `Remove ${groupState.name}`,
      }}
      isVisible={showRemoveGroupAlert}
      hideBodyScroll={true}
    />);

  return (
    <Fragment>
      <Accordion title={groupState.name + `: Queries ${rows.length}`} defaultOpen={true} key={group} testId={`provider-network-import-grid-group__${groupState.name}-accordion`}>
        {table}
        <div className="d-flex justify-content-end align-items-center">
          {/*
            TODO: add back when we have configurable steps
            <QESButton qesTestId="provider-network-import-grid-group_remove" qesType="secondary-danger" disabled={isActive} className="me-2" onClick={() => setShowRemoveGroupAlert(true)}>Remove</QESButton>
          */}
          <QESButton qesTestId="provider-network-import-grid-group_run" disabled={!saga.providerSource} onClick={() => runGroup(group)}>Run</QESButton>
        </div>
      </Accordion>
      {showRemoveGroupAlert ? alert : ""}
    </Fragment>
  );
}

export const ProviderNetworkImportGridGroup = memo(nonMemoProviderNetworkImportGridGroup);
